import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { clsx } from 'clsx';
import { ComponentPropsWithRef } from 'react';
import { TooltipArrowIcon } from '../icons/react/tooltip-arrow.tsx';
import { defaultTooltipContentRender } from './content-render.tsx';
import {
  tooltipArrow,
  tooltipContent,
  tooltipSize,
  tooltipVariant,
} from './tooltip.css.ts';

export const TooltipProvider = TooltipPrimitive.Provider;

export const Tooltip = TooltipPrimitive.Root;

export const TooltipTrigger = (
  props: ComponentPropsWithRef<typeof TooltipPrimitive.Trigger>,
) => (
  <TooltipPrimitive.Trigger
    onClick={(e) => {
      e.preventDefault();
    }}
    {...props}
  />
);

export type TooltipContentProps = Omit<
  ComponentPropsWithRef<typeof TooltipPrimitive.Content>,
  'children' | 'color'
> & {
  arrowClassName?: string;
  color?: 'default' | 'prominent';
  size?: 'medium' | 'small';
  title?: string;
  description?: string;

  action?: React.ReactNode;

  /** allows to render custom layout */
  render?: ({
    title,
    description,
    action,
  }: {
    title?: string;
    description?: string;
    action?: React.ReactNode;
  }) => React.ReactNode;
};

export const TooltipContent = ({
  className,
  align = 'center',
  side = 'top',
  sideOffset = 4,
  arrowClassName,
  color = 'default',
  size = 'medium',
  title,
  description,
  action,
  render = defaultTooltipContentRender,

  ...props
}: TooltipContentProps) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      align={align}
      sideOffset={sideOffset}
      side={side}
      className={clsx(
        tooltipContent,
        tooltipSize[size],
        tooltipVariant[color],
        className,
      )}
      collisionPadding={6}
      onClick={(e) => e.stopPropagation()}
      onPointerDownOutside={(e) => {
        e.preventDefault();
      }}
      {...props}
    >
      {render({ title, description, action })}

      <TooltipPrimitive.Arrow
        className={clsx(tooltipArrow, arrowClassName)}
        width={size === 'small' ? 16 : 30}
        height={size === 'small' ? 7 : 13}
        asChild
      >
        <TooltipArrowIcon viewBox="0 0 30 13" />
      </TooltipPrimitive.Arrow>
    </TooltipPrimitive.Content>
  </TooltipPrimitive.Portal>
);
